import React, {useState, useEffect, useRef} from 'react';
import {observer} from 'mobx-react';
import {ISearchItem} from '../Search/Search';
import SearchResultItem from "./SearchResultItem";
import './SearchResult.scss';

interface ISearchResultProps {
    query: string;
    searchList: ISearchItem[];
}

const SearchResult: React.FC<ISearchResultProps> = ({searchList, query}) => {
    const [faded, setFaded] = useState<boolean>();
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setFadedState();
    }, [searchList]);

    useEffect(() => {
        window.addEventListener('resize', setFadedState);
        return () => window.removeEventListener('resize', setFadedState);
    }, []);

    const setFadedState = () => {
        const container = ref.current!;
        // Если контейнер переполнен и полоса прокрутки находится не в конце.
        if (container.clientHeight + container.scrollTop < container.scrollHeight)
            !faded && setFaded(true);
        else
            faded && setFaded(false);
    }

    const renderFade = () => <div className="search-result-fade" />;

    return (
        <>
            <div className="search-result" onScroll={setFadedState} ref={ref}>
                {searchList.map(item => <SearchResultItem key={item.fullPath} item={item} query={query} />)}
            </div>
            {faded && renderFade()}
        </>
    );
}

export default observer(SearchResult);
